<template>
  <div class="content mt-25 mb-80 flexHB main">
    <xn-left :list="categoryTree.children??[]" :category-name="categoryTree.categoryName??''" :index="categoryId" @click="handle"></xn-left>
    <!--    文章列表-->
    <div class="right" v-if="title!=''">
      <div class="title-box"><span class="curr">{{title}}</span></div>
      <div class="list">
        <div class="item flexH" v-for="item in articleList" :key="item.id" style="cursor: pointer;" @click="articleDetail(item)">
          <div>
            <img v-if="item.mainImage!=''" :src="item.mainImage" alt="">
            <div v-else class="time-box">
              <span class="num">{{item.releaseTimeDay}}</span>
              <span>/</span>
              <div>
                <p>{{item.releaseTimeMonth}}月</p>
                <p>{{item.releaseTimeYear}}</p>
              </div>
            </div>
          </div>
          <div class="ml-58" style="width: 520px">
            <p class="title fontE1">{{item.articleTitle}}</p>
            <p :class="singlePageYn!=1?'desc fontE2 mb-10': 'desc fontE3 mb-10'">{{item.contentSummary}}</p>
            <p v-if="singlePageYn!=1">
              <span class="time mr-33">{{item.releaseTime}}</span>
              <span class="name">{{item.articleOrigin}}</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div v-show="pagination" class="block" style="margin-top: 30px;float: right;">
        <el-pagination
            background
            :current-page="articlePage"
            :page-size="articlePageSize"
            :page-sizes="[5, 10, 20, 50]"
            layout="prev, pager, next, sizes, jumper"
            :total="parseInt(tableCount)"
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        />
      </div>
    </div>

    <!--    静态页详情-->
    <div v-else>
      <branchBriefInfo v-if="articleViewId==='branchBriefInfo'" />
      <branchLeader v-if="articleViewId==='branchLeader'" />
      <branchOrganize v-if="articleViewId==='branchOrganize'" />
      <expertBook v-if="articleViewId==='expertBook'" />
      <expertDuty v-if="articleViewId==='expertDuty'" />
      <expert v-if="articleViewId==='expert'" />
      <memberAllCompany v-if="articleViewId==='memberAllCompany'" />
      <memberCompany v-if="articleViewId==='memberCompany'" />
      <meetingService v-if="articleViewId==='meetingService'" />
      <standardFormulate v-if="articleViewId==='standardFormulate'" />
      <articleDetail v-if="articleViewId==='' && articleContent.id!==''" :article-id="articleContent.id" />
    </div>

  </div>
</template>
<script>
import { getTwoList } from "@/api/articleCategory"
import { postPageList } from "@/api/article"
// 导入静态页
import branchBriefInfo from "@/views/branch/briefInfo"
import branchLeader from "@/views/branch/leader"
import branchOrganize from "@/views/branch/organize"
import expertBook from "@/views/expert/book"
import expertDuty from "@/views/expert/duty"
import expert from "@/views/expert/expert"
import memberAllCompany from "@/views/member/allCompany"
import memberCompany from "@/views/member/company"
import meetingService from "@/views/meeting/meetingService"
import standardFormulate from "@/views/standard/formulate"
import articleDetail from "@/views/article/detail"

export default {
  inject: ['reload'],
  components: {
    branchBriefInfo,
    branchLeader,
    branchOrganize,
    expertBook,
    expertDuty,
    expert,
    memberAllCompany,
    memberCompany,
    meetingService,
    standardFormulate,
    articleDetail
  },
  data() {
    return {
      categoryTree: [],
      articleListUrl: '/list',
      parentId: '',
      categoryId: '',
      categoryName: '',
      singlePageYn: '',
      articlePage: 1,
      articlePageSize: 5,
      articleList: [],
      articleDetailUrl: '/article',
      articleViewId: '',
      articleContent: {
        id: 0,
        articleTitle: ''
      },
      title: '',
      pagination: false,
      tableCount: 0,
    }
  },
  watch: {
    '$route.query.parentId'(val,oldVal) {
      if(val != oldVal) this.reload()
    },
    '$route.query.categoryId'(val,oldVal) {
      if(val != oldVal) this.reload()
    },
    parentId(){
      this.getCategoryList()
    },
    // 文章分类
    categoryName(){
      this.goToArticleList();
    }
  },
  methods: {
    // 分类切换
    handle(value) {
      if(parseInt(this.categoryId)===parseInt(value.id)){
        return
      }
      this.categoryId = value.id
      this.categoryName = value.categoryName
      this.singlePageYn = value.singlePageYn
      this.articleList = []
      this.articleViewId = ''
      this.articleContent= {
        id: 0,
        articleTitle: ''
      }
    },
    handleCurrentChange(val){
      this.articlePage = val
      this.goToArticleList()
    },
    handleSizeChange(val){
      this.articlePageSize = val
      this.goToArticleList()
    },
    // 二级分类列表
    getCategoryList() {
      const _t = this
      _t.articleViewId = ''
      getTwoList({
        parentId: _t.parentId
      }).then((result)=>{
        if(result.status === 'OK'){
          _t.categoryTree = result.data
          if(_t.categoryTree && _t.categoryTree.children.length>0 && _t.categoryId==''){
            _t.categoryId = _t.categoryTree.children[0].id
            _t.categoryName = _t.categoryTree.children[0].categoryName
            _t.singlePageYn = _t.categoryTree.children[0].singlePageYn
          } else if(_t.categoryTree && _t.categoryTree.children.length>0 && _t.categoryId!='') {
            _t.categoryTree.children.forEach(function (item, index){
              if(parseInt(item.id)==parseInt(_t.categoryId)){
                _t.categoryName = item.categoryName
                _t.singlePageYn = item.singlePageYn
              }
            })
          }
        }
      })
    },
    // 文章列表
    goToArticleList(){
      const _t = this
      _t.pagination = false
      postPageList({
        articleCategoryId: _t.categoryId,
        page: _t.articlePage,
        pageSize: _t.articlePageSize
      }).then((result)=>{
        if(result.status == 'OK'){
          _t.articleList = result.data.rows
          _t.tableCount = result.data.count
          //  总条数大于每页显示的条数时显示分页
          if (_t.tableCount > _t.articlePageSize) {
            _t.pagination = true
          }
          _t.articleListChange()
        }
      })
    },
    // 跳转至文章详情
    articleDetail(article){
      // if(article.articleType==1){
        this.$router.push({
          path: this.articleDetailUrl,
          query: {
            id: article.id
          }
        })
      // }
    },
    // 文章列表发生变化
    articleListChange(){
      this.articleViewId = ''
      if(parseInt(this.articleList.length)===1 && parseInt(this.singlePageYn)===1){
        this.articleContent = this.articleList[0]
        if(parseInt(this.articleContent.articleType)===2){ // 静态页
          this.articleViewId = this.articleContent.articleViewId!==''? this.articleContent.articleViewId: '';
        }
        this.title = '';
      }else{
        this.title = this.categoryName
      }
    }
  },
  created() {
    this.parentId = this.$route.query.parentId
    this.categoryId = this.$route.query.categoryId ?? ''
  }
}
</script>
<style lang="less" scoped>
.left {
  width: 350px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
  .item {
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #909097;
    &:first-child {
      background: url(../assets/img/icon_left_bg.png) no-repeat;
      background-size: 100% 100%;
      color: #fff;
      font-size: 24px;
      height: 120px;
    }
    &.curr {
      color: #0D53BC;
      position: relative;
      &::after {
        position: absolute;
        left: 0;
        width: 4px;
        height: 60px;
        background: #0D53BC;
        content: '';
      }
    }
  }
}
.right {
  width: 905px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.05);
  padding: 30px;
  .item {
    padding: 30px 0;
    border-bottom: 1px solid #F8F8FB;
      img {
        width: 272px;
        height: 140px;
        flex-shrink: 0;
        object-fit: cover;
      }
      .time-box {
        width: 272px;
        height: 140px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 2px solid #C1C1C9;
        span {
          font-size: 36px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #B7B7B7;
          line-height: 60px;
        }
        .num {
          font-size: 48px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #0D53BC;
          line-height: 60px;
        }
        p {
          font-size: 14px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #B7B7B7;
          line-height: 20px;
          margin-left: 4px;
        }
      }
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #171717;
        line-height: 30px;
      }

      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5F5F6A;
        line-height: 30px
      }
      .time {
        font-size: 14px;
        color: #909097;
        line-height: 30px;
      }
      .name {
        font-size: 14px;
        color: #0D53BC;
        line-height: 30px;
      }
    }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #F8F8FB;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1B252C;
      &::after {
        width: 100%;
        height: 2px;
        background: #0D53BC;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0d53bc;
  color: #FFF;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #FFFFFF;
  color: #606266;
  min-width: 30px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
}
</style>
